export default __webpack_public_path__ + "static/media/Subjugator Sword.b2cb116e.jpg";